import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import HomeIcon from '@material-ui/icons/Home';
import {useSelector, useDispatch} from "react-redux";
import {transitionToHome} from "../../modules/Transition/actions";
import {OptionButton, ProfileButton} from "./index";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  homeButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    margin: "auto",
    fontSize: "1rem",
    textOverflow: "ellipsis"
  },
}));

const Header = () => {
  // Get the current state from Store
  const rootState = useSelector(state => state);
  const path = rootState.router.location.pathname;

  const dispatch = useDispatch();

  // Change the header title according to the current page
  let title = "Judge!";
  if (/\/detail\/*/.test(path)) {
    title = rootState.detail.question
  } else if (path === '/post') {
    title = "質問を投稿"
  } else if (path === '/profile') {
    title = "マイページ"
  }

  const classes = useStyles();

  return (
      <div className={classes.root}>
        <AppBar position="fixed" color="grey[50]">
          <Toolbar>
            <IconButton edge="start" className={classes.homeButton} color="inherit" aria-label="menu"
                        onClick={() => dispatch(transitionToHome())} >
              <HomeIcon />
            </IconButton>
            <Typography variant="h2" className={classes.title}>{title}</Typography>

            <div>
              {(/\/detail\/*/.test(path)) ? (
                  <OptionButton />
              ) : (
                  <ProfileButton />
              )}
            </div>

          </Toolbar>
        </AppBar>
      </div>
  );
}

export default Header